var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 328,
    height: 328,
    viewBox: "0 0 328 328",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F68282",
    stroke: "#242424",
    strokeWidth: 4,
    strokeLinejoin: "bevel",
    d: "M326 326H2V2h324z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M326 2c0 178.94-145.06 324-324 324C2 147.06 147.06 2 326 2z",
    fill: "#7563E7",
    stroke: "#242424",
    strokeWidth: 4,
    strokeLinejoin: "bevel"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2c178.94 0 324 145.06 324 324C147.06 326 2 180.94 2 2z",
    fill: "#5ACBBC",
    stroke: "#242424",
    strokeWidth: 4,
    strokeLinejoin: "bevel"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzI4IiBoZWlnaHQ9IjMyOCIgdmlld0JveD0iMCAwIDMyOCAzMjgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHJlY3QgeD0iMzI2IiB5PSIzMjYiIHdpZHRoPSIzMjQiIGhlaWdodD0iMzI0IiB0cmFuc2Zvcm09InJvdGF0ZSgtMTgwIDMyNiAzMjYpIiBmaWxsPSIjRjY4MjgyIiBzdHJva2U9IiMyNDI0MjQiIHN0cm9rZS13aWR0aD0iNCIgc3Ryb2tlLWxpbmVqb2luPSJiZXZlbCIvPgogIDxwYXRoIGQ9Ik0zMjYgMi4wMDAwM0MzMjYgMTgwLjk0IDE4MC45NCAzMjYgMi4wMDAwMyAzMjZDMi4wMDAwMiAxNDcuMDYgMTQ3LjA2IDIuMDAwMDQgMzI2IDIuMDAwMDNaIiBmaWxsPSIjNzU2M0U3IiBzdHJva2U9IiMyNDI0MjQiIHN0cm9rZS13aWR0aD0iNCIgc3Ryb2tlLWxpbmVqb2luPSJiZXZlbCIvPgogIDxwYXRoIGQ9Ik0yIDEuOTk5OTlDMTgwLjk0IDEuOTk5OTkgMzI2IDE0Ny4wNiAzMjYgMzI2QzE0Ny4wNiAzMjYgMS45OTk5OSAxODAuOTQgMiAxLjk5OTk5WiIgZmlsbD0iIzVBQ0JCQyIgc3Ryb2tlPSIjMjQyNDI0IiBzdHJva2Utd2lkdGg9IjQiIHN0cm9rZS1saW5lam9pbj0iYmV2ZWwiLz4KPC9zdmc+Cg==";
export { SvgFrame4 as ReactComponent };